import toast from "react-hot-toast";
import { User } from "../../types";
import { baseUrl } from "./baseUrl";

export async function fetchAllUsers(): Promise<User[]> {
  const all: User[] = [];
  let page = 1;
  let hasNext = true;
  try {
    while (hasNext) {
      const url = new URL(`${baseUrl}/admin/users`);
      url.searchParams.set("page", String(page));

      const res = await fetch(url.toString(), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("admin_token")}`,
        },
      });

      const payload = (await res.json()) as {
        success: boolean;
        message: string;
        data: {
          users: User[];
          pagination: {
            hasNextPage: boolean;
          };
        };
      };
      if (!res.ok) {
        const m = payload.message?.toLowerCase?.();
        if (
          m === "invalid token" ||
          m === "jwt malformed" ||
          m === "jwt expired"
        ) {
          sessionStorage.removeItem("admin_token");
          toast.error("Session expired, please sign in again");
          window.location.href = "/auth/sign-in";
          return Promise.reject(new Error("Unauthorized"));
        }
        throw new Error(m || `HTTP error! status: ${res.status}`);
      }

      if (!payload.success) {
        throw new Error(payload.message || "Failed to fetch users");
      }

      all.push(...payload.data.users);
      hasNext = payload.data.pagination.hasNextPage;
      page += 1;
    }

    return all;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
}
